import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgCaretDown = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.69913 6.21057C4.16592 6.21057 4.66471 6.43448 4.96613 6.75619L12 13.736L19.1326 6.66096C19.4313 6.37014 19.8981 6.21057 20.3009 6.21057C21.2318 6.21057 22 6.95179 22 7.85C22 8.30039 21.7999 8.7199 21.4665 9.04161L13.2003 17.2104C12.8989 17.5322 12.4668 17.7895 12 17.7895C11.5652 17.7895 11.0984 17.4987 10.7997 17.2104L2.53348 9.04161C2.13337 8.65556 2 8.23605 2 7.85C2 6.95179 2.76554 6.21057 3.69913 6.21057Z", fill: props.fill }));
});
export default SvgCaretDown;
